import IntlMessages from "@lib/helpers/IntlMessages";
import {
  StyledMarkAllAsReadButton,
  StyledNotifyBadge,
  StyledNotifyButtonAll,
  StyledNotifyDropdown,
  StyledNotifyIcon,
  StyledNotifyList,
  StyledNotifyScrollSubmenu,
  StyledNotifyWrapper,
} from "./index.styled";
import { useEffect, useMemo } from "react";
import { Notification, NotificationEvents } from "@lib/types/Notification";
import { useTypedDispatch, useTypedSelector } from "@lib/redux";
import {
  fetchNotifications,
  markAllNotificationsAsRead,
} from "@lib/redux/slices/notifications";
import { IoCheckmarkDoneOutline, IoNotificationsSharp } from "react-icons/io5";
import { NotificationListItem } from "@lib/components/PageComponents/Notification";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { toast } from "react-toastify";
import { StyledHeaderButton } from "@lib/components/StyledComponents/layout";

const AppNotifications = () => {
  const dispatch = useTypedDispatch();
  const { data, unseenCount, error, loading } = useTypedSelector(
    (state) => state.notifications,
  );
  const { height } = useTypedSelector((state) => state.screen.header);

  const totalUnseenCount = unseenCount > 9 ? "9+" : unseenCount;

  useEffect(() => {
    dispatch(fetchNotifications({ page: 1, limit: 50 }));
  }, [dispatch]);

  const errorNotification = useMemo(() => {
    return {
      id: "error",
      event: NotificationEvents.Error,
      payload: {
        error: error,
      },
    } as Notification;
  }, [error]);

  return (
    <StyledNotifyWrapper height={height - 5}>
      <StyledNotifyDropdown
        menu={{
          items: [
            {
              key: 1,
              label: (
                <StyledFlex
                  style={{ justifyContent: "space-between", padding: "0 10px" }}
                >
                  <span className="header">
                    <IntlMessages id="common.notifications" />
                    {unseenCount > 0 && ` ( ${unseenCount} )`}
                  </span>

                  <StyledMarkAllAsReadButton
                    type="link"
                    onClick={() => {
                      dispatch(markAllNotificationsAsRead())
                        .unwrap()
                        .catch((error) => {
                          toast.error(error);
                        });
                    }}
                    icon={<IoCheckmarkDoneOutline />}
                  >
                    <IntlMessages id="common.markAllAsRead" />
                  </StyledMarkAllAsReadButton>
                </StyledFlex>
              ),
            },
            {
              key: 2,
              label: (
                <StyledNotifyScrollSubmenu>
                  <StyledNotifyList
                    dataSource={
                      error && data.length === 0 ? [errorNotification] : data
                    }
                    renderItem={(item: Notification, index: number) => {
                      return (
                        <NotificationListItem
                          key={item?.id || item?.tempId || index}
                          notification={item}
                        />
                      );
                    }}
                    loading={loading}
                  />
                </StyledNotifyScrollSubmenu>
              ),
            },
            {
              key: 3,
              label: (
                <StyledNotifyButtonAll to="/notifications">
                  <IntlMessages id="common.viewAll" />
                </StyledNotifyButtonAll>
              ),
            },
          ],
        }}
        overlayClassName="header-notify-messages no-padding"
        // getPopupContainer={(triggerNode) => triggerNode}
        trigger={["click"]}
        placement="bottom"
      >
        <StyledNotifyBadge
          count={totalUnseenCount}
          size="small"
          offset={[-10, 10]}
        >
          <StyledHeaderButton>
            <StyledNotifyIcon>
              <IoNotificationsSharp />
            </StyledNotifyIcon>
          </StyledHeaderButton>
        </StyledNotifyBadge>
      </StyledNotifyDropdown>
    </StyledNotifyWrapper>
  );
};

export default AppNotifications;
